import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-top: ${(props) => (props.menuIsOpen ? "-36.6vh" : "8vh")};
  align-items: center;
`;

export const SelectWrapper = styled.div`
  position: relative;
  display: inline-block;

  &:after {
    content: "\f0d7";
    font: normal normal normal 2vh/1 FontAwesome;
    position: absolute;
    pointer-events: none;
    left: 5%;
    top: 13px;
    font-size: 14px;
  }
`;

export const DataSelect = styled.select`
  -webkit-appearance: none;
  border-color: #5776ff;
  border-radius: 17.02px;
  outline: 0 !important;
  width: 70vw;
  direction: rtl;
  height: 38px;
  background-color: white !important;
  font-size: 14px;
  text-align: -webkit-center;
  text-align: center;
  text-align-last: center;
  -moz-text-align-last: center;
`;

export const customStyles = {
  option: (provided) => ({
    ...provided,
    color: "#969696",
    backgroundColor: "white !important",
    boxShadow: "none",
    borderColor: "#969696",
    fontFamily: "LucidaGrande",
    fontSize: "7.238095238095238vh",
    paddingTop: 0,
    paddingBottom: 0,
    "&:hover": {
      fontWeight: "bold",
    },
  }),
  menu: (provided) => ({
    ...provided,
    width: "100%",
    borderRadius: "0px 0px 17.02px 17.02px",
    marginBottom: 0,
    boxShadow: "none",
    marginTop: 0,
    border: "1px solid #969696",
    borderTop: 0,
    overflow: "hidden",
  }),
  menuList: (provided) => ({
    ...provided,
    boxShadow: "none",
    borderRadius: "0px 0px 17.02px 17.02px",
    paddingTop: 0,
    paddingBottom: 0,
    maxHeight: "59vh",
  }),
  control: (provided, state) => ({
    ...provided,
    boxShadow: "none",
    borderRadius: state.menuIsOpen ? "17.02px 17.02px 0px 0px" : "17.02px",
    borderColor: state.menuIsOpen ? "#969696" : "#5776FF",
    borderBottom: state.menuIsOpen ? 0 : "",
    "&:hover": {
      borderColor: "#969696",
    },
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    color: "#979797",
  }),
  container: (provided) => ({
    ...provided,
    width: "100%",
  }),
  valueContainer: (provided) => ({
    ...provided,
  }),
  indicatorSeparator: () => ({
    display: "none",
  }),
};

export const NextButton = styled.div`
  border-radius: 5px;
  color: "white";
  border-radius: 17.02px;
  height: 13.026819923371647vh;
  width: 48%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 8vh;
  color: white;
  font-weight: bold;
  font-size: 5.363984674329502vh;
  background: ${(props) => (props.isDisabled ? "#92A7F4" : "#5776ff")};
  cursor: ${(props) => (props.isDisabled ? "not-allowed" : "pointer")};

  &:hover {
    background: ${(props) => (props.isDisabled ? "" : "#3f5ed1")};
  }
`;
